import { render, staticRenderFns } from "./MainSectionOne.vue?vue&type=template&id=52b453b3&scoped=true&lang=pug&"
import script from "./MainSectionOne.vue?vue&type=script&lang=js&"
export * from "./MainSectionOne.vue?vue&type=script&lang=js&"
import style0 from "./MainSectionOne.vue?vue&type=style&index=0&id=52b453b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b453b3",
  null
  
)

export default component.exports